import { createI18n } from "vue-i18n";
import getLocale from "../locale";

import en from "@/locales/en.json";
import ie from "@/locales/ie.json";
import it from "@/locales/it.json";
import es from "@/locales/es.json";

const locale_config = getLocale();

export const i18n = createI18n({
  legacy: false,
  locale: locale_config,
  fallbackLocale: locale_config,
  messages: {
    en,
    ie,
    it,
    es,
  },
});
